import { useState, useEffect } from "react";
import TimeBar from "../TimeBar/TimeBar";
import WarningDefault from "../../assets/svgs/warningDefault.svg";
import WarningHighlight from "../../assets/svgs/warningHighlight.svg";
import WarningHover from "../../assets/svgs/warningHover.svg";
import NotesDefault from "../../assets/svgs/notesDefault.svg";
import NotesHighlight from "../../assets/svgs/notesHighlight.svg";
import NotesHover from "../../assets/svgs/notesHover.svg";
import SlackDefault from "../../assets/svgs/slackDefault.svg";
import SlackHighlight from "../../assets/svgs/slackHighlight.svg";
import styles from "./UserCard.module.css";

const UserCard = ({
  user,
  tasks,
  selectedDate,
  onSelectUser,
  isSelected,
  modal = false,
  isMobile,
  isModal,
  isReassignModal,
  activeCounter,
  onToggleCounter,
}) => {
  const [slackPressed, setSlackPressed] = useState(false);
  const [slackHovered, setSlackHovered] = useState(false);
  const [hoveredCounter, setHoveredCounter] = useState(null);

  const warningCount = tasks.filter((t) => t.IDOrigen < 0).length;
  const notesCount = tasks.filter((t) => t.Notas !== "").length;
  const hideAvatar = isMobile && isModal && !isReassignModal;

  const isDimmed = Number(user?.TurnoReal) === 3;

  const getCounterProps = (type) => {
    const count = type === "warning" ? warningCount : notesCount;
    const isHover = hoveredCounter === type;
    const isActive = activeCounter === type;

    if (isActive || isHover) {
      return {
        src: type === "warning" ? WarningHover : NotesHover,
        color: "#00ADC6",
        count,
      };
    }
    if (count > 0) {
      return {
        src: type === "warning" ? WarningHighlight : NotesHighlight,
        color: "#262626",
        count,
      };
    }
    return {
      src: type === "warning" ? WarningDefault : NotesDefault,
      color: "#999999",
      count,
    };
  };

  const handleCounterClick = (type) => {
    const willBeActive = activeCounter !== type;
    if (!willBeActive) {
      setHoveredCounter(null);
    }
    onToggleCounter(type, willBeActive);
  };

  const parseSlackData = (avatarUrl) => {
    const match = avatarUrl.match(/\/(T[^-]+)-(U[^-]+)/);
    return match
      ? { team: match[1], userId: match[2] }
      : { team: "", userId: "" };
  };
  const { team, userId } = parseSlackData(user.Avatar);
  const slackLink =
    team && userId ? `slack://user?team=${team}&id=${userId}` : "#";

  return (
    <div
      className={`${isMobile
        ? styles.userCardMobile
        : `${styles.userCard} ${isSelected ? (isMobile ? styles.selectedMobile : styles.selected) : ""}`
        } ${isDimmed ? styles.dimmed : ""}`}
      onClick={() => onSelectUser?.(user)}
    >
      {(isMobile && isReassignModal) ? (
        <div
          className={`
            ${styles.avatarContainer}
            ${styles.avatarContainerMobile}
            ${isDimmed ? styles.dimmed : ""}
          `}
        >
          <img
            src={user.Avatar}
            alt={user.Nombre}
            title={user.Nombre}
            className={styles.avatarMobile}
          />
        </div>
      ) : (
        !(isMobile && isModal) && (
          <div
            className={`
              ${styles.avatarContainer}
              ${isMobile ? styles.avatarContainerMobile : ""}
              ${isDimmed ? styles.dimmed : ""}
            `}
          >
            <img
              src={user.Avatar}
              alt={user.Nombre}
              title={user.Nombre}
              className={isMobile ? styles.avatarMobile : styles.avatar}
            />
          </div>
        )
      )}

      <div className={`${styles.details} ${isMobile ? styles.detailsMobile : ""}`}>
        {isMobile && !isModal && (
          <div className={styles.mobileHeader}>
            <span className={styles.userNameMobile}>{user.Nombre}</span>
            <div className={styles.iconsMobile}>
              {warningCount > 0 && (
                <div className={styles.counterMobile}>
                  <img src={WarningHighlight} alt="Warning" />
                  <span className={styles.counterNumberMobile}>{warningCount}</span>
                </div>
              )}
              {notesCount > 0 && (
                <div className={styles.counterMobile}>
                  <img src={NotesHighlight} alt="Notes" />
                  <span className={styles.counterNumberMobile}>{notesCount}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {isMobile && isReassignModal ? (
          <>
            <div className={`${styles.userNameReassign} ${isDimmed ? styles.dimmed : ""}`}>{user.Nombre}</div>
            <div
              className={`${styles.timeBarContainerReassign} ${isDimmed ? styles.dimmedBar : ""}`}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
              <div style={{ width: '75%' }}>
                <TimeBar tasks={tasks} selectedDate={selectedDate} admin={true} isMobile={isMobile} isReassignModal={isReassignModal} isModal={isModal} />
              </div>
              <label className={styles.customCheckboxContainer}>
                <input
                  type="checkbox"
                  checked={isSelected}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => onSelectUser(user)}
                  className={styles.hiddenCheckbox}
                />
                <span className={styles.customCheckbox}></span>
              </label>
            </div>
          </>
        ) : (
          <div
            className={
              `${isMobile ? styles.timeBarContainerMobile : styles.timeBarContainer} ` +
              `${isDimmed ? styles.dimmedBar : ""}`
            }
          >
            <TimeBar
              tasks={tasks}
              selectedDate={selectedDate}
              admin={true}
              isMobile={isMobile}
              isModal={isModal}
              isReassignModal={isReassignModal}
            />
          </div>
        )}

        {isMobile && isModal && !isReassignModal && (
          <div className={styles.mobileCountersWrapper}>
            <div className={styles.mobileCountersGrid}>
              {["warning", "notes"].map((type) => {
                const { src, color, count } = getCounterProps(type);
                return (
                  <div
                    key={type}
                    className={styles.counterItem}
                    onMouseEnter={() => setHoveredCounter(type)}
                    onMouseLeave={() => setHoveredCounter(null)}
                    onClick={() => handleCounterClick(type)}
                  >
                    <img src={src} alt={type} className={styles.icon} />
                    <span style={{ color }}>{count}</span>
                  </div>
                );
              })}

              <div className={styles.counterItem}>
                <a
                  href={slackLink}
                  className={styles.slackLink}
                  title="Abrir Slack"
                  onMouseEnter={() => setSlackHovered(true)}
                  onMouseLeave={() => {
                    setSlackHovered(false);
                    setSlackPressed(false);
                  }}
                  onMouseDown={() => setSlackPressed(true)}
                  onMouseUp={() => setSlackPressed(false)}
                >
                  <img
                    src={
                      isMobile && isModal
                        ? SlackDefault
                        : slackPressed || slackHovered
                          ? SlackHighlight
                          : SlackDefault
                    }
                    alt="Slack"
                    className={styles.slackIcon}
                  />
                </a>
              </div>
            </div>
          </div>
        )}


        {modal && !(isMobile && isReassignModal) ? (
          <label className={styles.customCheckboxContainer}>
            <input
              type="checkbox"
              checked={isSelected}
              onClick={(e) => e.stopPropagation()}
              onChange={() => onSelectUser(user)}
              className={styles.hiddenCheckbox}
            />
            <span className={styles.customCheckbox}></span>
          </label>
        ) : (
          !isMobile && (
            <div className={styles.counters}>
              {["warning", "notes"].map((type) => {
                const { src, color, count } = getCounterProps(type);
                return (
                  <div
                    key={type}
                    className={styles.counter}
                    onMouseEnter={() => setHoveredCounter(type)}
                    onMouseLeave={() => setHoveredCounter(null)}
                    onClick={() => handleCounterClick(type)}
                  >
                    <img src={src} alt={type} className={styles.icon} />
                    <span style={{ color }}>{count}</span>
                  </div>
                );
              })}
              <div className={styles.separator}></div>
              <a
                href={slackLink}
                className={styles.slackLink}
                title="Abrir Slack"
                onMouseEnter={() => setSlackHovered(true)}
                onMouseLeave={() => {
                  setSlackHovered(false);
                  setSlackPressed(false);
                }}
                onMouseDown={() => setSlackPressed(true)}
                onMouseUp={() => setSlackPressed(false)}
              >
                <img
                  src={slackPressed || slackHovered ? SlackHighlight : SlackDefault}
                  alt="Slack"
                  className={styles.slackIcon}
                />
              </a>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default UserCard;
